var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.167,23.946H25.58c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V25.946 C38.167,24.841,37.271,23.946,36.167,23.946z M34.167,34.532H27.58v-6.586h6.586V34.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.167,40.707H25.58c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V42.707 C38.167,41.602,37.271,40.707,36.167,40.707z M34.167,51.293H27.58v-6.586h6.586V51.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.167,57.468H25.58c-1.104,0-2,0.896-2,2v10.587c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V59.468 C38.167,58.363,37.271,57.468,36.167,57.468z M34.167,68.055H27.58v-6.587h6.586V68.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.293,23.946H42.707c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V25.946 C55.293,24.841,54.397,23.946,53.293,23.946z M51.293,34.532h-6.586v-6.586h6.586V34.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.293,40.707H42.707c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V42.707 C55.293,41.602,54.397,40.707,53.293,40.707z M51.293,51.293h-6.586v-6.586h6.586V51.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.293,57.468H42.707c-1.104,0-2,0.896-2,2v10.587c0,1.104,0.896,2,2,2h10.586c1.104,0,2-0.896,2-2V59.468 C55.293,58.363,54.397,57.468,53.293,57.468z M51.293,68.055h-6.586v-6.587h6.586V68.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,23.946H59.834c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2H70.42c1.104,0,2-0.896,2-2V25.946 C72.42,24.841,71.524,23.946,70.42,23.946z M68.42,34.532h-6.586v-6.586h6.586V34.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,40.707H59.834c-1.104,0-2,0.896-2,2v10.586c0,1.104,0.896,2,2,2H70.42c1.104,0,2-0.896,2-2V42.707 C72.42,41.602,71.524,40.707,70.42,40.707z M68.42,51.293h-6.586v-6.586h6.586V51.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,57.468H59.834c-1.104,0-2,0.896-2,2v10.587c0,1.104,0.896,2,2,2H70.42c1.104,0,2-0.896,2-2V59.468 C72.42,58.363,71.524,57.468,70.42,57.468z M68.42,68.055h-6.586v-6.587h6.586V68.055z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.02acf05cb2a0c95ee65d5c8c94a71ca8.svg";
export { ForwardRef as ReactComponent };